import { Typography } from '@/modules/perseo-billing/ui/react/src';
import { PdsIcon } from '@/modules/perseo-billing/ui/react/src/components/gamma';

const BILL_INFO =
  'Emitiremos la boleta una vez que la compra esté confirmada. Te llegará por correo electrónico. También podrás descargarla en Mis compras.';
const INVOICE_INFO =
  'Emitiremos la factura una vez que la compra esté confirmada. Te llegará por correo electrónico. También podrás descargarla en Mis compras.';
const RECEIPT_INFO =
  'Emitiremos el comprobante una vez que la compra esté confirmada. Te llegará por correo electrónico. También podrás descargarlo en Mis compras.';

const FeedBackInfo = ({
  isBill,
  isForeignDocument = false
}: {
  isBill: boolean;
  isForeignDocument?: boolean;
}) => {
  // TODO: Conditional message for foreign document?
  const message = isForeignDocument
    ? RECEIPT_INFO
    : isBill
      ? BILL_INFO
      : INVOICE_INFO;

  return (
    <div
      tabIndex={0}
      className="co-flex co-rounded-8px co-border-1 co-p-8px co-gap-8px co-border-pds-information-500 co-gap-x-2"
    >
      <div className="co-flex co-self-start co-p-1 co-flex-shrink-0">
        <PdsIcon icon="PdsInfoCircle" className="co-fill-pds-information-500" />
      </div>
      <Typography className="co-text-pds-neutral-900" leading="16px">
        {message}
      </Typography>
    </div>
  );
};

export default FeedBackInfo;
